import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { Link, useHistory } from "react-router-dom";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { callAPI } from "../../helper/apiUtils";
import { $crud } from "../../helper/CrudFactory";
import "./AddServices.css";


function AddServices(props) {
    const { isGerm, strings } = useContext(LanguageContext)
    const [service, setService] = useState('')
    const history = useHistory();
    const [isKjuup, setIsKjuup] = useState([])
    useEffect(() => {
        if (props.location.state) {
            setIsKjuup(props.location.state.isKjuup)
        }
    }, [props])
    const addService = async () => {
        const companyId = props.match.params.id
        if (service) {
            const { data } = await callAPI(`/company/${companyId}/service`, {
                'services[5]': service
            }, 'POST')
            console.log(data)
            if (data.status) {
                setService('')
                history.push({
                    pathname: "/cockpit",
                    search: `?tab=company&company=${encodeURIComponent(companyId)}`,
                })
            } else {
                $crud.notify({
                    type: 'error',
                    message: data.message
                })
            }
        } else {
            $crud.notify({
                type: 'error',
                message: strings.please_enter_service_name
            })
        }
    }

    return (
        <React.Fragment>
                <div class="following follower add-services">
                    <div className={`${isKjuup ? "main_heading main_heading-internal" : "main_heading"} add-services__heading`}>
                        <Link to={{ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(props.match.params.id)}` }}>
                            <span className={`material-symbols-outlined material-arrow-left ${isKjuup ? 'internal-arrow' : ''}`}>
                              keyboard_arrow_left
                            </span>
                        </Link>
                        {strings.add_services}
                    </div>
                    <div className="row m-0">
                        <div className="col-md-12 p-2">
                            <Form.Group controlId="formBasicPassword">
                                <Form.Label className="">{strings.services}</Form.Label>
                                <Form.Control value={service} onChange={e => setService(e.target.value)} type="text"
                                    className="add-services__input" />
                            </Form.Group>
                        </div>
                        <div className="col-md-12 p-2">
                            <button onClick={addService} className={isKjuup ? "kj-btn kj-btn--outline kj-btn--internal" : "kj-btn kj-btn--outline"} type="submit">
                                {strings.save_text}
                            </button>
                        </div>
                    </div>
                </div>
        </React.Fragment>
    );
}

export default AddServices;